<template>
    <div>
        <el-card style="position: relative;padding-bottom: 10px;">
            <div style="display: flex; align-items: center;">
                <div style="font-size: 16px;"><b>{{ "用户" }} : </b> {{ userName }}</div>
                <el-button :title="$t('message.title.changePW')" style="margin-left: 12px;" @click="setPsd()"
                    icon="el-icon-key">修改密码</el-button>
            </div>

        </el-card>
        <div class="nav">
            <div class="nav-item" v-for="item in list" :key="item.value" @click="navClick(item)"
                :class="{ active: activeId === item.value }">
                {{ item.label }}
                <span class="nav-span" v-if="item.hasResult">*</span>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            list: [
                { label: "详细信息", value: 0, path: '/Users/UserInfo' },
                { label: "角色权限", value: 1, path: '/Users/RolePermission' },
                { label: "首选项", value: 2, path: '/Users/UserPreferences' },
                { label: "权限转移", value: 3, path: '/Users/UserAuthorization' },
                { label: "用户组", value: 4, path: '/Users/UserGroup' },
                { label: "附件", value: 5, path: '/Users/UserAttachment' },
                { label: "历史操作", value: 6, path: '/Users/Userhistory' }
            ],
            userName: '',
        };

    },
    computed: {
        activeId() {
            this.userName = this.$store.state.showUserName;
            let { path } = this.$route;
            return this.list.find(i => i.path === path)?.value
        }
    },
    created() { },

    methods: {
        navClick(item) {
            this.$emit("click", item);
        },
        setPsd(res) {
            const { id, listTypeName } = this.$route.query
            var obj = {
                id,
                // name: res.listTypeName,
                name: listTypeName
            };
            this.$store.commit("setUserNewPsd", obj);
            this.$router.push("/AdminUpdatePsd");
        },
    },
};
</script>

<style scoped>
.nav {
    display: flex;
    flex: 0 50px;
    padding: 0 20px;
    border-bottom: #f6f6f6 1px solid;
}

.nav-item {
    font-size: 1em;
    height: 50px;
    margin: 5px 0.4em;
    padding: 1em 0.8em;
    position: relative;
    width: fit-content;
    cursor: pointer;
    box-sizing: border-box;
    word-break: keep-all;
    display: flex;
    align-content: center;
    align-items: center;
    transition: all 0.18s cubic-bezier(0.23, 1, 0.32, 1);
}

.nav-span {
    position: absolute;
    top: 10px;
    right: 0;
    font-size: 24px;
}

.active {
    font-size: 1.2em;
    font-weight: 600;
}

.active::after {
    content: "";
    width: 40%;
    height: 3px;
    background: #353ecb;
    left: 50%;
    transform: translateY(-50%);
    top: 85%;
    transform: translateX(-50%);
    position: absolute;
}
</style>